<template>
	<thank-you-page-recurring />
</template>

<script>
import { dataLayer } from '../../mixins/gtc'
import { dates } from '../../mixins/dates'
import ThankYouPageRecurring from './ThankYouPageRecurring'

export default {
	components: {
		ThankYouPageRecurring
	},
	computed: {
        user () {
            return this.$root.user
        }
    },
	mixins: [
		dataLayer
	],
    mounted () {

		this.$_dataLayer_dataLayerTYNew()
	}

}

</script>